import React, { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../../MainContext";
import { request } from "../../../../request";
import Swal from "sweetalert2";
import { Box, CircularProgress } from "@mui/material";
import { modifyTransaction } from "../_functions/modifyTransaction";
import DatePickerInput from "./DatePicker/DatePickerInput";
import { convertToApproximateString } from "../../Inputs/convert";
import { Transaction as TransactionComponent } from "./Transaction/Transaction";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Card, CardContent, Typography, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CollapsableBox from "../../../CollapsibleBox/CollapsableBox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
interface Transaction {
    _id: string;
    id: string;
    timeStamp: string;
    date?: string;
    joined_transaction_id: string;
    comment?: string;
    signature?: string;
    toBeBounded?: boolean;
    main?: boolean;
    deletable?: boolean;
}

interface Profit {
    hrach?: number;
    artyom?: number;
    fahad?: number;
}

interface JoinedTransaction {
    _id: string;
    transactions: Transaction[];
    profits?: Profit;
    finished?: boolean;
}

export const TransactionList: React.FC<any> = ({ transactions, dateRange, getFilteredHistory, amountRange }) => {
    const { openState, boxOpener, darkMode, customers, accounts, inactiveAccounts, joinedTransactions: joinedTransactionsRaw, updateTransactions, users, transactions: transactionsRaw } = useContext(MainContext);
    const [infoData, setInfoData] = useState<any>(null);
    const [expandedId, setExpandedId] = useState<string | null>(null);
    const [editingTimeStamp, setEditingTimeStamp] = useState<any>({});

    const [joinedTransactions, setJoinedTransactions] = useState<JoinedTransaction[]>([]);

    useEffect(() => {
        if (joinedTransactionsRaw?.length && transactions?.length) {
            const newJoinedTransactions: any[] = [];
            // joinedTransactionsRaw.map((joinedTransaction: any) => {
            //     let neededTransactions: any = transactions.filter((t: any) => t.joined_transaction_id === joinedTransaction._id).map((t: any) => modifyTransaction(t, [...customers, ...accounts, ...inactiveAccounts]));

            //     // if (myTransactions.length === 0) {
            //     //     neededTransactions = transactions.filter((t: Transaction) => t.joined_transaction_id === joinedTransaction._id).map((t: Transaction) => modifyTransaction(t, [...customers, ...accounts, ...inactiveAccounts]));
            //     // }

            //     return {
            //         ...joinedTransaction,
            //         transactions: neededTransactions.sort((a: any, b: any) => new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime()),
            //     };
            // });
            transactions
                .sort((a: any, b: any) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime())
                .forEach((t: any) => {
                    let neededTransactions: any = transactions.filter((tt: any) => tt.joined_transaction_id === t.joined_transaction_id).map((t: any) => modifyTransaction(t, [...customers, ...accounts, ...inactiveAccounts]));

                    // if (myTransactions.length === 0) {
                    //     neededTransactions = transactions.filter((t: Transaction) => t.joined_transaction_id === joinedTransaction._id).map((t: Transaction) => modifyTransaction(t, [...customers, ...accounts, ...inactiveAccounts]));
                    // }

                    newJoinedTransactions.push({
                        ...joinedTransactionsRaw.find((jt: any) => jt._id.toString() === t.joined_transaction_id),
                        transactions: neededTransactions
                            .sort((a: any, b: any) => new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime())
                            .map((e: any) => {
                                console.log(e, t);
                                return { ...e, main: e.id.toString() === t._id.toString() };
                            }),
                    });
                });

            setJoinedTransactions(
                newJoinedTransactions.filter((jt: any) => jt.transactions.length)
                // .sort((a: any, b: any) => {
                //     const dateToUse = dateRange[0].getTime() - 24 * 60 * 60 * 1000;
                //     const t1 = b.transactions.find((t: any) => new Date(t.timeStamp).getTime() > dateToUse);
                //     const t2 = a.transactions.find((t: any) => new Date(t.timeStamp).getTime() > dateToUse);
                //     return new Date(t1?.timeStamp || 0).getTime() - new Date(t2?.timeStamp || 0).getTime();
                // })
            );
        }
    }, [joinedTransactionsRaw, transactions, dateRange, amountRange]);

    const returnTransactions = async (transactionId: string) => {
        try {
            await Swal.fire({
                title: "Are you sure?",
                text: "You are about to delete a transaction",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    const prevReturnables = JSON.parse(window.localStorage.getItem("returnables") || "[]");
                    try {
                        const { data } = await request.get(`/transaction/get-back-to/${transactionId}`);
                        window.localStorage.setItem("returnables", JSON.stringify([...prevReturnables, ...data]));
                        updateTransactions();
                        getFilteredHistory();
                    } catch (error: any) {
                        // window.localStorage.setItem("returnables", JSON.stringify(prevReturnables));
                        Swal.showValidationMessage(`Request failed: ${error.message}`);
                    }
                },
            });
        } catch (error) {
            console.error(error);
        }
    };

    const handleHistoryValue = async (id: any) => {
        if (expandedId === id) {
            setExpandedId(null);
            return;
        }
        try {
            const res = await request.get(`/history/value/${id}`);
            setInfoData(res.data);
            setExpandedId(id);
        } catch (error) {}
    };

    const changeFinishedBound = async (id: string) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You are about to change finished status of bounded transaction",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        });

        if (result.isConfirmed) {
            await request.post(`/transaction/change-finished-bound/${id}`);
            updateTransactions();
        }
    };

    const getActualRate = (transactions: any) => {
        let froms = 0;
        let tos = 0;

        for (const transaction of transactions) {
            if (transaction.from.length === 1 && transaction.to.length === 1) {
                froms += transaction.from.reduce((acc: any, curr: any) => acc + curr.amount, 0);
                tos += transaction.to.reduce((acc: any, curr: any) => acc + curr.amount, 0);
            } else if (transaction.from.length > 1 || transaction.to.length > 1) {
                if (!transaction.from.every((acc: any, curr: any) => acc === curr.currency_name, transaction.from[0].currency_name) || !transaction.to.every((acc: any, curr: any) => acc === curr.currency_name, transaction.from[0].currency_name)) {
                    return "";
                }
            }
        }

        if (froms > tos) {
            return `Actual rate ${(froms / tos).toFixed(3)}`;
        } else {
            return `Actual rate ${(tos / froms).toFixed(3)}`;
        }
    };
    console.log(editingTimeStamp);
    return (
        <div className={"transactionList"}>
            <div className={"content"}>
                <div className={"transactions"}>
                    {joinedTransactions.map((joinedTransaction) => {
                        console.log(joinedTransaction);
                        const signature = joinedTransaction.transactions.map((t) => users.find((u: any) => u._id.toString() === t.signature?.toString())?.login).join(" - ");
                        let timer: any;
                        const onLongPress = () => window.localStorage.login === "root" && setEditingTimeStamp({ ...editingTimeStamp, [joinedTransaction._id]: !!!editingTimeStamp[joinedTransaction._id] });

                        const start = () => (timer = setTimeout(onLongPress, 600));
                        const stop = () => clearTimeout(timer);
                        return (
                            joinedTransaction.transactions.length > 0 && (
                                <div className={"joinedTransaction"}>
                                    <div className={"topper"}>
                                        {!joinedTransaction.transactions[0]?.toBeBounded || joinedTransaction.transactions.length <= 1 ? (
                                            <div>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    {expandedId === joinedTransaction.transactions[0].id ? (
                                                        <CloseIcon sx={{ marginRight: "20px", cursor: "pointer" }} onClick={() => setExpandedId(null)} />
                                                    ) : (
                                                        <InfoOutlinedIcon sx={{ marginRight: "20px", cursor: "pointer" }} onClick={() => handleHistoryValue(joinedTransaction.transactions[0].id)} />
                                                    )}
                                                    <p onDoubleClick={onLongPress} onTouchStart={start} onTouchEnd={stop} onMouseDown={start} onMouseUp={stop} className="topperText">
                                                        {editingTimeStamp[joinedTransaction._id] && (
                                                            <>
                                                                <DatePicker
                                                                    selected={editingTimeStamp[joinedTransaction._id] === true ? null : editingTimeStamp[joinedTransaction._id]}
                                                                    onChange={(date) => {
                                                                        //@ts-ignore
                                                                        setEditingTimeStamp({ ...editingTimeStamp, [joinedTransaction._id]: new Date(date.getTime() + 6 * 60 * 60 * 1000) });
                                                                        setTimeout(() => {
                                                                            //@ts-ignore
                                                                            document.activeElement?.blur();
                                                                        }, 50);
                                                                    }}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    disabledKeyboardNavigation
                                                                    onFocus={(e) => e.target.blur()}
                                                                    dropdownMode="select"
                                                                    portalId="root-portal"
                                                                    className="p-2  border border-gray-300 rounded-lg shadow-md focus:outline-none focus:ring-blue-500 dark:bg-gray-800 dark:text-white hover:cursor-pointer"
                                                                />
                                                                <button
                                                                    disabled={editingTimeStamp[joinedTransaction._id] === true}
                                                                    onClick={() => {
                                                                        const result = window.confirm("You sure?");
                                                                        if (result) {
                                                                            request.post("/transaction/edit-timestamp", { _id: joinedTransaction.transactions[0].id, timeStamp: editingTimeStamp[joinedTransaction._id] });
                                                                            setEditingTimeStamp({ ...editingTimeStamp, [joinedTransaction._id]: false });
                                                                            getFilteredHistory();
                                                                            updateTransactions();

                                                                            Swal.fire({
                                                                                icon: "success",
                                                                                title: "OK",
                                                                            });
                                                                        }
                                                                    }}
                                                                    style={{ padding: "5px", marginLeft: "5px", backgroundColor: "white", color: "black" }}
                                                                >
                                                                    Save
                                                                </button>
                                                            </>
                                                        )}
                                                        {!editingTimeStamp[joinedTransaction._id] && joinedTransaction.transactions[0].date} - {signature} - {getActualRate(joinedTransaction.transactions)}
                                                    </p>
                                                </div>

                                                <Collapse in={expandedId === joinedTransaction.transactions[0].id}>
                                                    <Box
                                                        sx={{
                                                            display: expandedId === joinedTransaction.transactions[0].id ? "flex" : "",
                                                            flexWrap: expandedId === joinedTransaction.transactions[0].id ? "wrap" : "",
                                                            gap: 2,
                                                            justifyContent: "center",
                                                            mt: 2,
                                                        }}
                                                    >
                                                        {infoData?.map((item: any) => (
                                                            <Card
                                                                key={item._id}
                                                                variant="outlined"
                                                                sx={{
                                                                    backgroundColor: "#ffffff",
                                                                    borderRadius: 2,
                                                                    padding: 2,
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                    width: {
                                                                        xs: "100%",
                                                                        sm: "calc(50% - 16px)",
                                                                    },
                                                                }}
                                                            >
                                                                <CardContent sx={{ paddingBottom: "16px !important" }}>
                                                                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                                        {item.name}
                                                                    </Typography>

                                                                    {item.type && (
                                                                        <Typography variant="caption" color="text.secondary" gutterBottom>
                                                                            Type: {item.type}
                                                                        </Typography>
                                                                    )}

                                                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, mb: 0.5, display: "block" }}>
                                                                        Currencies:
                                                                    </Typography>

                                                                    <ul style={{ paddingLeft: "1rem", margin: 0 }}>
                                                                        {item.currencies.map((cur: any, idx: number) => (
                                                                            <li
                                                                                key={idx}
                                                                                style={{
                                                                                    fontSize: "0.85rem",
                                                                                    marginBottom: "4px",
                                                                                    color: "#333",
                                                                                }}
                                                                            >
                                                                                <strong>Value:</strong> {cur.value} {cur.currency_name} {cur.avg !== undefined && <span style={{ color: "#777" }}>| Avg: {cur.avg}</span>}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </CardContent>
                                                            </Card>
                                                        ))}
                                                    </Box>
                                                </Collapse>
                                            </div>
                                        ) : (
                                            <div>
                                                <p className={"topperText"}>{signature}</p>
                                            </div>
                                        )}

                                        <p className={"topperText"}>
                                            {joinedTransaction.transactions
                                                .map((t) => t.comment)
                                                .filter(Boolean)
                                                .join(", ")}
                                        </p>

                                        {joinedTransaction.profits && (
                                            <>
                                                {Math.abs(joinedTransaction.profits.hrach ?? 0) > 1 && <p className={"topperText"}>H: {convertToApproximateString(joinedTransaction.profits.hrach!)} AMD</p>}
                                                {Math.abs(joinedTransaction.profits.artyom ?? 0) > 1 && <p className={"topperText"}>A: {convertToApproximateString(joinedTransaction.profits.artyom!)} AMD</p>}
                                                {Math.abs(joinedTransaction.profits.fahad ?? 0) > 1 && <p className={"topperText"}>F: {convertToApproximateString(joinedTransaction.profits.fahad!)} AMD</p>}
                                            </>
                                        )}

                                        {joinedTransaction.transactions.find((e) => e.main)?.deletable && (
                                            //@ts-ignore
                                            <button className={"backButton"} onClick={() => returnTransactions(joinedTransaction.transactions.find((e) => e.main)?.id)}>
                                                ↑
                                            </button>
                                        )}
                                    </div>

                                    <div className={"transactionCopmonents"}>
                                        {joinedTransaction.transactions
                                            .filter((e) => e.main)
                                            .map((transaction, indexik, arr) => (
                                                <TransactionComponent getFilteredHistory={getFilteredHistory} key={transaction.id} transaction={transaction} arr={arr} indexik={indexik} joined_transaction={joinedTransaction} />
                                            ))}
                                        {joinedTransaction.transactions.find((e) => !e.main) && (
                                            <CollapsableBox title="Rest bounds" isOpen={openState[joinedTransaction.transactions.find((e) => e.main)?.id || "0"]} setIsOpen={() => boxOpener(joinedTransaction.transactions.find((e) => e.main)?.id || "0")}>
                                                {joinedTransaction.transactions
                                                    .filter((e) => !e.main)
                                                    .map((transaction, indexik, arr) => (
                                                        <TransactionComponent getFilteredHistory={getFilteredHistory} key={transaction.id} transaction={transaction} arr={arr} indexik={indexik} joined_transaction={joinedTransaction} />
                                                    ))}
                                            </CollapsableBox>
                                        )}
                                    </div>

                                    {joinedTransaction.transactions[0].toBeBounded && (
                                        <>
                                            <hr />
                                            <label className={"checkboxLabel"}>
                                                <p className={"checkboxText"}>Finished: </p>
                                                <input type="checkbox" hidden onChange={() => changeFinishedBound(joinedTransaction._id)} />
                                                <span className={joinedTransaction.finished ? "checked" : "unchecked"}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className={"checkIcon"} viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" clipRule="evenodd" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </>
                                    )}
                                </div>
                            )
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
